import React from 'react';
import PropTypes from 'prop-types';

import { testSetType } from 'types';
import TestSetItem from './components/TestSetItem';

import './style.scss';

const TestSetsList = ({ testSets, selectedTestSet, selectTestSet }) => (
  <div styleName="list">
    {testSets.map(testSet => (
      <TestSetItem
        key={testSet.id}
        testSet={testSet}
        selectedTestSet={selectedTestSet}
        selectTestSet={selectTestSet}
      />
    ))}
  </div>
);

/* eslint-disable react/no-typos */
TestSetsList.propTypes = {
  testSets: PropTypes.arrayOf(testSetType).isRequired,
  selectedTestSet: testSetType.isRequired,
  selectTestSet: PropTypes.func.isRequired,
};

export default TestSetsList;
